export const REFERRER_KEYS = ['referral_aid', 'referral_source', 'referrer_anonymous_id'];
